// frontend/src/components/EdaPrepare/EdaPrepareWarnings.tsx

import React from 'react';

interface Props {
  warnings: any;
}

export const EdaPrepareWarnings: React.FC<Props> = ({ warnings }) => {
  const warningItems = warnings?.items || [];

  if (warningItems.length === 0) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
        borderRadius: '12px',
        padding: '20px',
        border: '1px solid #1a4a7a',
        marginBottom: '24px'
      }}>
        <h3 style={{ color: '#4fc3f7', margin: '0 0 16px 0' }}>⚠️ Alertas</h3>
        <div style={{
          padding: '16px',
          textAlign: 'center',
          color: '#66bb6a',
          background: 'rgba(102, 187, 106, 0.05)',
          borderRadius: '8px',
          border: '1px solid #66bb6a'
        }}>
          ✅ Nenhum alerta encontrado. Preparação saudável!
        </div>
      </div>
    );
  }

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #1a4a7a',
      marginBottom: '24px'
    }}>
      <h3 style={{ color: '#4fc3f7', margin: '0 0 16px 0' }}>⚠️ Alertas</h3>
      {warningItems.map((warning: any, index: number) => (
        <div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            padding: '12px 16px',
            background: 'rgba(255, 193, 7, 0.1)',
            borderRadius: '8px',
            border: '1px solid #ffc107',
            marginBottom: '8px',
            color: '#ffc107'
          }}
        >
          <span style={{ fontSize: '20px' }}>⚠️</span>
          <div>
            <strong style={{ display: 'block' }}>{warning.type || 'Alerta'}</strong>
            <p style={{ margin: '4px 0 0 0', fontSize: '13px', opacity: 0.8 }}>
              {warning.message}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};